// extracted by mini-css-extract-plugin
export var locale = "components-__LocalDate-module___locale";